import { useState } from "react"
import { Download } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { exportCsv } from "@/lib/export-csv"
import { toast } from "sonner"

interface ExportButtonProps {
  entity: string
  filters: Record<string, string | undefined>
  visibleColumns?: string[]
}

export function ExportButton({ entity, filters, visibleColumns }: ExportButtonProps) {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    setIsExporting(true)
    try {
      await exportCsv(entity, filters, visibleColumns)
      toast.success("Eksport CSV zakończony")
    } catch {
      toast.error("Błąd eksportu CSV")
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            onClick={handleExport}
            disabled={isExporting}
            className="h-9 w-9"
          >
            <Download size={16} className={isExporting ? "animate-pulse" : ""} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Eksportuj CSV</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
